export enum ExerciseType {
  LESSON = 'LESSON',
  EXAM = 'EXAM',
  QUIZ = 'QUIZ',
}
